import { render, staticRenderFns } from "./TeacherOtoSelect.vue?vue&type=template&id=3ec19210&"
import script from "./TeacherOtoSelect.vue?vue&type=script&lang=js&"
export * from "./TeacherOtoSelect.vue?vue&type=script&lang=js&"
import style0 from "./TeacherOtoSelect.vue?vue&type=style&index=0&id=3ec19210&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports